import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Amplify, Auth } from "aws-amplify";
import { DEV_AUTH_CONFIG } from "../aws-config";
import { useRecoilState } from "recoil";
import {
  developerAccessTokenState,
  developerEmailState,
} from "../global-state";

const DeveloperLoginCallback = () => {
  const history = useHistory();
  const location = useLocation();
  const [developerAccessToken, setDeveloperAccessToken] = useRecoilState(
    developerAccessTokenState
  );
  const [developerEmail, setDeveloperEmail] =
    useRecoilState(developerEmailState);

  useEffect(() => {
    Amplify.configure(DEV_AUTH_CONFIG);
  }, []);

  useEffect(() => {
    const handleCallback = async () => {
      if (!history) {
        return;
      }

      const urlParams = new URLSearchParams(location.search);
      const state = urlParams.get("state");
      const path = state ? decodeURIComponent(state) : "/dashboard";
      try {
        Amplify.configure(DEV_AUTH_CONFIG);
        const session = await Auth.currentSession();
        const email = session.getIdToken().payload["cognito:username"];
        setDeveloperAccessToken(session.getAccessToken().getJwtToken());
        setDeveloperEmail(email);
        history.push(path);
      } catch (error) {
        console.error("Error during callback handling", error);
        history.push("/developer-login");
      }
    };

    handleCallback();
  }, [history]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <h1>Redirecting...</h1>
    </div>
  );
};

export default DeveloperLoginCallback;
